<template>
  <UtilSPLanding />
</template>

<script>
import { generateMetaTags } from '@/lib/generate-meta'
import UtilSPLanding from '@/components/utils/payment/secure-payments/UtilSPLanding'

export default {
  name: 'SecurePayments',
  components: {
    UtilSPLanding
  },
  methods: {
    openSecurePaymentModal() {
      this.$modal.open('ModalSecurePayment')
    }
  },
  head: {
    title() {
      return {
        inner: this.$t('headMeta.securePayments')
      }
    },
    meta() {
      return generateMetaTags({
        image: require('@/assets/images/meta/secure-payments.jpg')
      })
    }
  }
}
</script>

<style lang="scss">
.sitemap-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, 19%);
  grid-gap: 1.5rem 1%;
}

#app.smAndDown {
  .sitemap-columns {
    grid-template-columns: repeat(auto-fit, 30%);
  }
}
</style>
